import { HttpClient } from '../httpClient';
import { DataResponse } from '../responses/baseResponse';
import TimesheetUnlockRequestData from '../requests/timesheetUnlockRequestData';
import TimesheetUnlockRequestResponse from '../models/timesheetUnlockRequestResponse';
import TimesheetUnlockRequestModel from '../models/timesheetUnlockRequestModel';
import SetTimesheetUnlockRequestStatusData from '../requests/setTimesheetUnlockRequestStatusData';

const httpClient = new HttpClient();

export const requestTimesheetUnlock = async (data: TimesheetUnlockRequestData) => {
  return httpClient.post<DataResponse<TimesheetUnlockRequestResponse>>({
    url: '/v1/timesheetsLock/requestTimesheetUnlock',
    payload: data,
    requiresToken: true,
  });
};

export const getTimesheetUnlockRequests = async () => {
  return httpClient.get<DataResponse<TimesheetUnlockRequestModel[]>>({
    url: '/v1/timesheetsLock/getTimesheetUnlockRequests',
    requiresToken: true
  })
}

export const setTimesheetUnlockRequestStatus = async (data: SetTimesheetUnlockRequestStatusData) => {
  return httpClient.put<DataResponse<TimesheetUnlockRequestModel[]>>({
    url: '/v1/timesheetsLock/setTimesheetUnlockRequestStatus',
    payload: data,
    requiresToken: true,
  });
}